module.exports = __webpack_public_path__ + "img/11088016_L.3f7b3e61.png";